<template lang="pug">
div
  header
    .pull-right
      router-link.btn.btn-primary(to="/admin/api_clients/new")
        i.fa.fa-plus
        |
        | New API Key
    h1 API Keys

  LoaderOverlay(:loading="loading")
    table.table.table-striped
      thead
        tr
          th Name
          th Key
          th Disabled
          th
      tbody
        tr(v-for="apiClient in apiClientsStore.apiClients" :key="apiClient.id")
          td {{ apiClient.name }}
          td
            Secret(:value="apiClient.jwt")
          td
            CheckboxIcon(:checked="apiClient.disabled")
          td.text-right
            span.btn-group
              router-link.btn.btn-default(:to="`/admin/api_clients/${apiClient.id}/edit`")
                i.fa.fa-pencil
              button.btn.btn-danger(type="button" @click="destroy(apiClient.id)")
                i.fa.fa-trash
</template>

<script>
  import { mapStores } from 'pinia'
  import { useApiClientsStore } from '@/stores/api_clients'
  import { copyTextToClipboard } from '@/utils/clipboard'
  import store from '@/store'

  import CheckboxIcon from '@/components/shared/checkbox_icon.vue'
  import LoaderOverlay from '@/components/shared/loader_overlay.vue'
  import Secret from '@/components/shared/secret.vue'

  export default {
    components: {
      CheckboxIcon,
      LoaderOverlay,
      Secret
    },

    data() {
      return {
        loading: true
      }
    },

    computed: {
      ...mapStores(useApiClientsStore)
    },

    async mounted() {
      await this.apiClientsStore.fetch()

      this.loading = false
    },

    methods: {
      async destroy(id) {
        if (confirm('Are you sure?')) {
          this.loading = true

          await this.apiClientsStore.destroy(id)

          this.loading = false
        }
      }
    }
  }
</script>
